var map = {
  "./fi_reports_channel.js": "76037",
  "./mrp_planning_channel.js": "48063",
  "./notifications_channel.js": "95018",
  "./ui_updates_channel.js": "26851",
  "./web_notifications_channel.js": "70219"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18923;
